import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FileDropZone } from "../../_metronic/layout/components/dropzone/FileDropZone";
import FormFooterButtons from "../components/FormFooterButtons";
import { Card } from "react-bootstrap";
import {
    wardList,
    toleWardOne,
    toleWardTwo,
    toleWardThree,
    toleWardFour,
    toleWardFive,
    toleWardSix,
    toleWardSeven,
    toleWardEight,
    toleWardTen,
    toleWardNine,
    toleWardEleven,
    toleWardTwelve,
} from "../data/ToleList";
import {
    toleFiveQn,
    toleFourQn,
    toleOneQn,
    toleThreeQn,
    toleTwoQn,
    toleSixQn,
    toleSevenQn,
    toleEightQn,
    toleNineQn,
    toleTenQn,
    toleElevenQn,
    toleTwelveQn,
} from "../data/houseSurvey";
import {
    ward,
    naturalResource,
    wardQuestion,
    selectedLanguage,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";

const TourismPlace = (props) => {
    const [selectedWard, setSelectedWard] = useState(0);
    const history = useHistory();

    const wardData = [
        {
            question: toleOneQn,
            toleList: toleWardOne,
        },
        {
            question: toleTwoQn,
            toleList: toleWardTwo,
        },
        {
            question: toleThreeQn,
            toleList: toleWardThree,
        },
        {
            question: toleFourQn,
            toleList: toleWardFour,
        },
        {
            question: toleFiveQn,
            toleList: toleWardFive,
        },
        {
            question: toleSixQn,
            toleList: toleWardSix,
        },
        {
            question: toleSevenQn,
            toleList: toleWardSeven,
        },
        {
            question: toleEightQn,
            toleList: toleWardEight,
        },
        {
            question: toleNineQn,
            toleList: toleWardNine,
        },
        {
            question: toleTenQn,
            toleList: toleWardTen,
        },
        {
            question: toleElevenQn,
            toleList: toleWardEleven,
        },
        {
            question: toleTwelveQn,
            toleList: toleWardTwelve,
        },
    ];
    const getToleList = (ward) => {
        if (ward == 1) {
            return toleWardOne;
        } else if (ward == 2) {
            return toleWardTwo;
        } else if (ward == 3) {
            return toleWardThree;
        } else if (ward == 4) {
            return toleWardFour;
        } else if (ward == 5) {
            return toleWardFive;
        } else if (ward == 6) {
            return toleWardSix;
        } else if (ward == 7) {
            return toleWardSeven;
        } else if (ward == 8) {
            return toleWardEight;
        } else if (ward == 9) {
            return toleWardNine;
        } else if (ward == 10) {
            return toleWardTen;
        } else if (ward == 11) {
            return toleWardEleven;
        } else {
            return toleWardTwelve;
        }
    };
    const handleWardChange = (ward) => {
        setSelectedWard(ward);
    };
    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={
                    props.data
                        ? props.data
                        : {
                              name: "",
                              wardNumber: "",
                              toleName: "",
                              streetName: "",
                              description: "",
                              ownership: "",
                              yearlyTouristCount: "",
                              yearlyDomesticTouristCount: "",
                              nearByMarketName: "",
                              marketDistance: "",
                              hotelCount: "",
                              resourcePersonInfoName: "",
                              resourcePersonInfoContact: "",
                          }
                }
                validate={(values) => {
                    const errors = {};
                    // if (!values.name) {
                    //     errors.name = 'Required';
                    // }
                    // else
                    // if (
                    //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    // ) {
                    //     errors.email = 'Invalid email address';
                    // }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    console.log(values);
                    setTimeout(() => {
                        props.submit(values);
                        setSubmitting(false);
                        history.goBack();
                    }, 400);
                }}
            >
                {({
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    handleReset,
                }) => (
                    <>
                        <form
                            className="form survey-form"
                            onSubmit={handleSubmit}
                        >
                            <Card>
                                <Card.Body>
                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                पर्यटकीय स्थलको नाम
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="पर्यटकीय स्थलको नाम"
                                                name="name"
                                                onChange={handleChange}
                                                value={values.name}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="name"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                {wardQuestion[selectedLanguage]}
                                            </label>
                                            <select
                                                className="form-control"
                                                id="wardNumber"
                                                name="wardNumber"
                                                onChange={handleChange}
                                                handleWardChange={handleWardChange(
                                                    values.wardNumber
                                                )}
                                                value={
                                                    values.wardNumber
                                                        ? values.wardNumber
                                                        : "selectOne"
                                                }
                                            >
                                                <option
                                                    value="selectOne"
                                                    disabled
                                                >
                                                    कुनै एक छान्नुहोस्
                                                </option>
                                                {wardList.map((woda) => (
                                                    <option value={woda.value}>
                                                        {woda[selectedLanguage]}
                                                    </option>
                                                ))}
                                            </select>
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="wardNumber"
                                                component="div"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        {values.wardNumber && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    {
                                                        wardData[
                                                            values.wardNumber -
                                                                1
                                                        ].question[
                                                            selectedLanguage
                                                        ]
                                                    }
                                                </label>
                                                <select
                                                    className="form-control"
                                                    id="toleName"
                                                    name="toleName"
                                                    onChange={handleChange}
                                                    value={
                                                        values.toleName
                                                            ? values.toleName
                                                            : "selectOne"
                                                    }
                                                >
                                                    <option
                                                        value="selectOne"
                                                        disabled
                                                    >
                                                        कुनै एक छान्नुहोस्
                                                    </option>
                                                    {getToleList(
                                                        values.wardNumber
                                                    ).map((woda) => (
                                                        <option
                                                            value={woda.value}
                                                        >
                                                            {
                                                                woda[
                                                                    selectedLanguage
                                                                ]
                                                            }
                                                        </option>
                                                    ))}
                                                </select>
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="toleName"
                                                    component="div"
                                                />
                                            </div>
                                        )}

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                मार्गको नाम
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="मार्गको नाम"
                                                name="streetName"
                                                onChange={handleChange}
                                                value={values.streetName}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="streetName"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                पर्यटकीय स्थलको विवरण(विशेषता)
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="पर्यटकीय स्थलको विवरण (विशेषता)"
                                                name="description"
                                                onChange={handleChange}
                                                value={values.description}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="description"
                                                component="div"
                                            />
                                        </div>

                                        {values.description && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    पर्यटकीय स्थलको स्वामित्व
                                                </label>
                                                <select
                                                    className="form-control"
                                                    multiple={true}
                                                    id="ownership"
                                                    name="ownership"
                                                    onChange={handleChange}
                                                    value={
                                                        values.ownership
                                                            ? values.ownership
                                                            : "selectOne"
                                                    }
                                                >
                                                    <option
                                                        value="selectOne"
                                                        disabled
                                                    >
                                                        कुनै एक छान्नुहोस्
                                                    </option>
                                                    <option value="private">
                                                        निजि /पब्लिक
                                                    </option>
                                                    <option value="community">
                                                        सामुदायिक
                                                    </option>
                                                    <option value="others_tourist_place">
                                                        अन्य
                                                    </option>
                                                </select>
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="ownership"
                                                    component="div"
                                                />
                                            </div>
                                        )}

                                        {values.ownership ==
                                            "others_tourist_place" && (
                                            <div className="col-md-6">
                                                <label className="form-control-label">
                                                    अन्य भए खुलाउनुहोस्
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="अन्य भए खुलाउनुहोस्"
                                                    name="ownershipOther"
                                                    onChange={handleChange}
                                                    value={
                                                        values.ownershipOther
                                                    }
                                                />
                                                <ErrorMessage
                                                    className="invalid-feedback"
                                                    name="ownershipOther"
                                                    component="div"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                स्वदेशी (आन्तरिक पर्यटक आगमन
                                                सङ्ख्या वार्षिक ) जना
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="स्वदेशी (आन्तरिक पर्यटक आगमन सङ्ख्या वार्षिक ) जना"
                                                name="yearlyTouristCount"
                                                onChange={handleChange}
                                                value={
                                                    values.yearlyTouristCount
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="yearlyTouristCount"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                विदेशी पर्यटक आगमन सङ्ख्या (
                                                वार्षिक ) जना
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="विदेशी पर्यटक आगमन सङ्ख्या (वार्षिक)जना"
                                                name="yearlyDomesticTouristCount"
                                                onChange={handleChange}
                                                value={
                                                    values.yearlyDomesticTouristCount
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="yearlyDomesticTouristCount"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                नजिकको बजार केन्द्रको नाम
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="नजिकको बजार केन्द्रको नाम"
                                                name="nearByMarketName"
                                                onChange={handleChange}
                                                value={values.nearByMarketName}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="nearByMarketName"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                नजिकको बजार केन्द्र सम्मको दूरी
                                                (कि.मी.)
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="नजिकको बजार केन्द्र सम्मको दूरी (कि.मी.)"
                                                name="marketDistance"
                                                onChange={handleChange}
                                                value={values.marketDistance}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="marketDistance"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                पर्यटकीय स्थलमा रहेका
                                                होटल,लज,रेस्टुरा संख्या
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="पर्यटकीय स्थलमा रहेका होटल,लज,रेस्टुरा संख्या"
                                                name="hotelCount"
                                                onChange={handleChange}
                                                value={values.hotelCount}
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="hotelCount"
                                                component="div"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                श्रोत व्यक्तिको नाम थर
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="श्रोत व्यक्तिको नाम थर"
                                                name="resourcePersonInfoName"
                                                onChange={handleChange}
                                                value={
                                                    values.resourcePersonInfoName
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="resourcePersonInfoName"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label className="form-control-label">
                                                स्रोत व्यक्तिको सम्पर्क नम्बर
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="स्रोत व्यक्तिको सम्पर्क नम्बर "
                                                name="resourcePersonInfoContact"
                                                onChange={handleChange}
                                                value={
                                                    values.resourcePersonInfoContact
                                                }
                                            />
                                            <ErrorMessage
                                                className="invalid-feedback"
                                                name="resourcePersonInfoContact"
                                                component="div"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">
                                            <label>फोटो</label>
                                            <ImageUploader
                                                fileListContent={
                                                    props.fileListContent
                                                }
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="card-footer text-right">
                                        <FormFooterButtons />
                                    </div>
                                </Card.Body>
                            </Card>
                        </form>
                    </>
                )}
            </Formik>
        </div>
    );
};

export default TourismPlace;
